export default __webpack_public_path__ + "static/media/building-icon.e20a7989.svg";